module.exports = new __parcel__URL__("PermissionDenied.bfcb6211.svg").toString();